import { CommonResponseModel } from "../global-response-object";

export class StockTransferItemDto {
    id: number;
    itemType: string;
    itemId: number;
    buyerId: number;
    excelNo: number;
    loaction: number;
    rackId: number;
    quantity: number;
    sts: number;
    dcQty: number;
    allocatedQty: number;
    uomId: number;
    remarks: string;
    challandate: Date;
    isActive: boolean;
    createdAt: Date;
    createdUser: string | null;
    updatedAt: Date;
    updatedUser: string | null;
    versionFlag: number;
    m3ItemId:number
    xlNo:number
    dcQuantity:number
    rackPositionId:number
    negativeStock:number
    stockId:number
    stcQnuantity:number

    constructor(data?: Partial<StockTransferItemDto>) {
        Object.assign(this, data);
    }


}